export default __webpack_public_path__ + "static/media/team57.09e78bbb.JPG";